export default __webpack_public_path__ + "static/media/Frame 6970.2acd1f48.png";